export default "__VITE_ASSET__0qan2GL7_ec$EbvoOAG3kQ__"